import axios from "axios";
import { errorResponse } from "src/store/common";
import { alertMessages, mutateApiKey } from "src/constants";
import { getAccessTokenCookie } from "src/shared/Login";

export const configMutationClimatology = (data:string, token?:string|null)=>{
    const cookieToken = getAccessTokenCookie(`accessToken`);
    if(cookieToken){
      return {
        method: 'post',
        url:`${process.env.REACT_APP_GRAPHQL_URL}`,
        headers: {
          'Authorization': `Bearer ${cookieToken}`,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': `${process.env.REACT_APP_GRAPHQL_URL}`
        },
        data: data
      }
    }
    else{
      return {
        method: 'post',
        url:`${process.env.REACT_APP_GRAPHQL_URL}`,
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': `${process.env.REACT_APP_GRAPHQL_URL}`
        },
        data: data
      }
    }
  }

export const createUpdateApiKey = async(params: any,addAlert: any) => {
    try {
        let data = JSON.stringify({
          query: mutateApiKey,
          variables:{
            apiKey: params.apiKey          
        }
        });
        let config = configMutationClimatology(data, null);
        return(
        new Promise(function(resolve,reject){
        axios(config)
          .then(async function (response: any) {
            if(response.data.errors){
              return reject(new Error(response))
            }
            else{
              return resolve(response)
  
            }
          })
          .catch(function (error: any) {
            console.log('error', error);
            return reject(new Error(error))
          });
        })
        )
      }
      catch (error) {
        console.log('error', error);
        errorResponse(error, addAlert,alertMessages.apiKey);
  
      }
  };